function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9785F"
    },
    d: "M414.897,512h-70.621c-9.751,0-17.655-7.904-17.655-17.655V70.621 c0-9.751,7.904-17.655,17.655-17.655h70.621c9.751,0,17.655,7.904,17.655,17.655v423.724C432.552,504.096,424.648,512,414.897,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA6955"
    },
    d: "M344.276,52.966c-9.75,0-17.655,7.904-17.655,17.655v423.724c0,9.75,7.905,17.655,17.655,17.655 V52.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD782"
    },
    d: "M383.774,349.369l21.365-64.095c0.604-1.812,0.604-3.77,0-5.583l-21.365-64.095 c-1.342-4.024-7.033-4.024-8.374,0l-21.365,64.095c-0.604,1.812-0.604,3.772,0,5.583l21.365,64.095 C376.74,353.394,382.432,353.394,383.774,349.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B8273"
    },
    d: "M185.379,512H97.103c-9.751,0-17.655-7.904-17.655-17.655V105.931 c0-9.751,7.904-17.655,17.655-17.655h88.276c9.751,0,17.655,7.904,17.655,17.655v388.414C203.034,504.096,195.13,512,185.379,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#876E64"
    },
    d: "M79.448,105.931v388.414c0,9.75,7.905,17.655,17.655,17.655V88.276 C87.353,88.276,79.448,96.18,79.448,105.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD782"
    },
    d: "M145.429,367.025l21.365-64.095c0.604-1.812,0.604-3.772,0-5.583l-21.365-64.095 c-1.342-4.024-7.033-4.024-8.374,0l-21.365,64.095c-0.604,1.812-0.604,3.772,0,5.583l21.365,64.095 C138.396,371.049,144.087,371.049,145.429,367.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M308.966,512H220.69c-9.751,0-17.655-7.904-17.655-17.655V17.655C203.034,7.904,210.938,0,220.69,0 h88.276c9.751,0,17.655,7.904,17.655,17.655v476.69C326.621,504.096,318.717,512,308.966,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M220.69,512L220.69,512V0l0,0c-9.751,0-17.655,7.904-17.655,17.655v476.69 C203.034,504.096,210.938,512,220.69,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD782"
    },
    d: "M269.015,322.887l21.365-64.095c0.604-1.812,0.604-3.77,0-5.583l-21.365-64.095 c-1.342-4.024-7.033-4.024-8.374,0l-21.365,64.095c-0.604,1.812-0.604,3.77,0,5.583l21.365,64.095 C261.982,326.911,267.673,326.911,269.015,322.887z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.034,
    y: 35.31,
    style: {
      fill: "#FFD782"
    },
    width: 123.586,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.034,
    y: 70.621,
    style: {
      fill: "#FFD782"
    },
    width: 123.586,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.034,
    y: 423.724,
    style: {
      fill: "#FFD782"
    },
    width: 123.586,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.034,
    y: 459.034,
    style: {
      fill: "#FFD782"
    },
    width: 123.586,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.448,
    y: 441.379,
    style: {
      fill: "#FFD782"
    },
    width: 123.586,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.621,
    y: 441.379,
    style: {
      fill: "#FFD782"
    },
    width: 105.931,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.621,
    y: 105.931,
    style: {
      fill: "#FFD782"
    },
    width: 105.931,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.448,
    y: 141.241,
    style: {
      fill: "#FFD782"
    },
    width: 123.586,
    height: 17.655
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 203.034,
    y: 35.31,
    style: {
      fill: "#FFC36E"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.034,
    y: 70.621,
    style: {
      fill: "#FFC36E"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.448,
    y: 141.241,
    style: {
      fill: "#FFC36E"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.448,
    y: 441.379,
    style: {
      fill: "#FFC36E"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.621,
    y: 105.931,
    style: {
      fill: "#FFC36E"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.621,
    y: 441.379,
    style: {
      fill: "#FFC36E"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.034,
    y: 423.724,
    style: {
      fill: "#FFC36E"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.034,
    y: 459.034,
    style: {
      fill: "#FFC36E"
    },
    width: 17.655,
    height: 17.655
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.2eba97c899e5b3c7bd9993e99a94226a.svg";
export { ForwardRef as ReactComponent };